import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { MdoInterimReportAdvice } from '@common/customControls/bariatrics';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextInputStringSchema } from '@common/validation/utils/getTextInputStringSchema';

export type BariPreResumeMdoInterimData = {
    hervatten: Exclude<MdoInterimReportAdvice, MdoInterimReportAdvice.notYet> | null;
    toelichting: string | null;
};

export type BariPreResumeMdoInterimReadKey = keyof BariPreResumeMdoInterimData;
export type BariPreResumeMdoInterimReadLabel = 'Hervatten in zorgpad' | 'Toelichting';

export const bariPreResumeMdoInterimReadSchema: TypedReadSchema<
    BariPreResumeMdoInterimReadKey,
    BariPreResumeMdoInterimReadLabel
>[] = [
    {
        items: [
            { key: 'hervatten', label: 'Hervatten in zorgpad' },
            { key: 'toelichting', label: 'Toelichting' },
        ],
    },
];

const bariPreResumeMdoInterimFinal: TypedSchema<BariPreResumeMdoInterimData> = {
    hervatten: Koi.valid(
        ...Object.values(MdoInterimReportAdvice).filter((advice) => advice !== MdoInterimReportAdvice.notYet)
    ),
    toelichting: getTextInputStringSchema(),
};

const bariPreResumeMdoInterimDraft: TypedSchema<BariPreResumeMdoInterimData> =
    addAllowNull(bariPreResumeMdoInterimFinal);

export const bariPreResumeMdoInterimDraftSchema = Koi.object(bariPreResumeMdoInterimDraft);
export const bariPreResumeMdoInterimFinalSchema = Koi.object(bariPreResumeMdoInterimFinal);
